import React from 'react';
import './App.css';
import Map from './components/map/Map';
import SearchSpecies from './components/searchSpecies/SearchSpecies';
import logo from './assets/images/info_fauna_logo.png';
import 'bootstrap/dist/css/bootstrap.css';
import RightPanel from "./components/rightPanel/RightPanel";
import LeftPanel from "./components/leftPanel/LeftPanel";
import LangPanel from "./components/langPanel/LangPanel";
import ReactGA from 'react-ga';

ReactGA.initialize('UA-268645-2');
ReactGA.pageview('/carto-react');

const textes = {
    'titre': {
      'fr': 'Centre national\n' +
        'de données et d\'informations\n' +
        'sur la faune de Suisse',
      'de': 'Nationales Daten- und\n' +
        'Informationszentrum\n' +
        'der Schweizer Fauna',
      'it': 'Centro nazionale\n' +
        'di dati e informazioni\n' +
        'sulla fauna svizzera',
      'en': 'Swiss topic\n' +
        'center on fauna'
    }
};

class App extends React.Component {

    constructor(props) {
        super(props);

        let locale;

        if (localStorage.getItem('if.carto.lang') === null) {
            if (navigator.language.indexOf(('fr', 'de', 'it', 'en')) > -1) {
                locale = navigator.language.substring(0, 2);
            } else {
                locale = 'fr';
            }
        } else {
            locale = localStorage.getItem('if.carto.lang');
        }

        this.state = {
            nuesp: window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1),
            pixel: [],
            locale: locale
        };
    }

    nuespChangeCallback = (nuesp) => {
        this.setState({nuesp: nuesp});
        ReactGA.pageview('/carto-react/' + nuesp);
    };

    pcChangeCallback = (pixel) => {
        this.setState({pixel: pixel})
    };

    langChangeCallback = (lang) => {
        this.setState({locale: lang})
    };

    yrChangeCallBack = (yr) => {
        this.setState({yrChange: yr})
    };

    render() {
        return (
            <div className="App">
                <header className="App-header">
                    <div className="App-header-item"><img src={logo} alt="Logo info fauna"
                                                          className="App-header-logo"/>
                    </div>
                    <div className="App-header-item App-h2">
                        <span className="App-h1">info fauna</span><br/>
                        {textes.titre[this.state.locale]}
                    </div>
                    <SearchSpecies callbackFromParent={this.nuespChangeCallback} locale={this.state.locale}/>
                    <LangPanel locale={this.state.locale} callbackFromParent={this.langChangeCallback}/>
                </header>
                <main className="App-article">
                    <Map nuesp={this.state.nuesp} locale={this.state.locale}
                         callBackFromParent={this.pcChangeCallback}  yrChangeCallBack={this.yrChangeCallBack}/>
                </main>
                <LeftPanel nuesp={this.state.nuesp} locale={this.state.locale} yrChange={this.state.yrChange}/>
                <RightPanel nuesp={this.state.nuesp} pixel={this.state.pixel} locale={this.state.locale}/>
            </div>
        );
    }
}

export default App;
